import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
  ImageTitle,
} from './styled';

const Manage = () => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <ImageTitle>Spendings</ImageTitle>
          <StyledImage
            src={messages['home.manage.image.src']}
            alt={messages['home.manage.image.alt']}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.manage.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.manage.paragraph" />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Manage;
